import * as React from 'react';

interface IProps {
  rootElementRef: React.RefObject<HTMLDivElement | null>;
  targetElementRef: React.RefObject<HTMLDivElement | null>;
  condition?: boolean;
  handler: () => void;
}

export const useObserver = ({ rootElementRef, targetElementRef, condition, handler }: IProps) => {
  const observer = React.useMemo(() => {
    if (condition === false) {
      return null;
    }

    return new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handler();
        }
      },
      {
        root: rootElementRef.current,
        rootMargin: '200px',
        threshold: 0,
      },
    );
  }, [rootElementRef, handler, condition]);

  React.useEffect(() => {
    if (targetElementRef.current && observer) {
      observer.observe(targetElementRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetElementRef]);
};
